import React from 'react';
import Principal from './principal/Principal';

const Dashboard = ({ user, onToggleSidebar }) => {
  return (
    <div style={{ minHeight: '100vh', background: '#f4f6f8' }}>
      <Principal user={user} onToggleSidebar={onToggleSidebar} />
    </div>
  );
};

export default Dashboard;
